/**
 * FinaCertificate API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  deleteFinaCertificate,
  getFinaCertificate,
  uploadFinaCertificate,
} from "../generated/fina-certificate/fina-certificate";

import { wrapMethod } from "./utils";

export const finaCertificate = {
  /** @see uploadFinaCertificate */
  uploadFinaCertificate: wrapMethod(uploadFinaCertificate),

  /** @see getFinaCertificate */
  getFinaCertificate: wrapMethod(getFinaCertificate),

  /** @see deleteFinaCertificate */
  delete: wrapMethod(deleteFinaCertificate),
} as const;

export type FinaCertificateApi = typeof finaCertificate;
